import Flux from 'lib/flux';
import BookingConstants from 'constants/booking';

const BookingStore = Flux.createStore({
  name: 'booking',

  getInitialState() {
    return {
      accepting: false,
      acceptCompleted: false,
      acceptFailed: false,
      acceptError: null,
      rejecting: false,
      rejectingCompleted: false,
      rejectingError: null,
      rejectingFailed: false,
    };
  },

  actions: [
    [
      BookingConstants.REJECT,
      function (_contents) {
        this.state = this.state.merge({
          rejecting: true,
          rejectingCompleted: false,
          rejectingFailed: false,
          rejectingError: {},
        });
      },
    ],

    [
      BookingConstants.REJECT_COMPLETED,
      function () {
        this.state = this.state.merge({
          rejecting: false,
          rejectingCompleted: true,
          rejectingFailed: false,
          rejectingError: null,
        });
      },
    ],

    [
      BookingConstants.REJECT_FAILED,
      function (payload) {
        this.state = this.state.merge({
          rejecting: false,
          rejectingCompleted: false,
          rejectingFailed: true,
          rejectingError: payload.responseJSON.message,
        });
      },
    ],

    [
      BookingConstants.ACCEPT,
      function (_contents) {
        this.state = this.state.merge({
          accepting: true,
          acceptCompleted: false,
          acceptFailed: false,
          acceptError: {},
        });
      },
    ],

    [
      BookingConstants.ACCEPT_COMPLETED,
      function () {
        this.state = this.state.merge({
          accepting: false,
          acceptCompleted: true,
          acceptFailed: false,
          acceptError: null,
        });
      },
    ],

    [
      BookingConstants.ACCEPT_FAILED,
      function (payload) {
        this.state = this.state.merge({
          accepting: false,
          acceptCompleted: false,
          acceptFailed: true,
          acceptError: payload.responseJSON.message,
        });
      },
    ],
  ],
});

export default BookingStore;
